// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.role-toggle-button {
  width: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border: 2px solid #ffcc34;
  border-radius: 999px;
  padding: 2px 4px;
  background: #fff;
  color: #333;
  cursor: pointer;
  margin: 0 auto;
  margin-top: -7px;
  position: relative;
  z-index: 1;
  padding-right: 0px;
}

.role-toggle-button .material-icons {
  font-size: 16px;
  color: #555;
}

.role-toggle-count {
  font-weight: 600;
  font-size: 11px;
  color: #333;
}

.role-toggle-button.active {
  background: #fff !important;   /* ปุ่มปกติ */
  border-color: #ffcc34 !important;
  color: #333 !important;
}

.role-toggle-button {
  background: #ffec9d !important;
  border-color: #ffcc34 !important;
  color: #222 !important;
}

.role-toggle-button:hover {
  background: #ffb400 !important;      /* สีเมื่อ hover */
  border-color: #ffb400 !important;
  color: #fff !important;
}

.role-toggle-icon {
  font-size: 14px !important;
  color: #f5be28;
}

.staff:hover ~ .role-toggle-button {
  transform: translateX(-6px);   /* ขยับไปซ้ายหรือเปลี่ยนสี ฯลฯ */
  transition: transform 0.15s ease;
}

ol.organizational-chart .staff.class-executive {
    background-color: #024f42 !important;
    color: #fff !important;
}

ol.organizational-chart .staff.class-managing_director,
ol.organizational-chart .staff.class-general_manager,
ol.organizational-chart .staff.class-director {
    background-color: #047775 !important;
    color: #fff !important;
}

ol.organizational-chart .staff.class-senior_manager,
ol.organizational-chart .staff.class-manager {
    background-color: #55b493 !important;
    color: #fff !important;
}

ol.organizational-chart .staff {
    background-color: #80b157;
    color: #fff;
}

/* Box Staff Card */
ol.organizational-chart .staff.card ~ .role-toggle-button {
  transform: translateX(-6px);   /* ขยับไปซ้ายหรือเปลี่ยนสี ฯลฯ */
  transition: transform 0.15s ease;
}

ol.organizational-chart .staff.card {
    height: auto;
    margin-left: 0px;
    width: 144px;
    border-radius: 8px;
    margin-bottom: 0px;
}

ol.organizational-chart .staff.card .photo {
    top: 2px;
    left: 50%;
    margin-left: -5px;
}

ol.organizational-chart .staff.card .image-circle {
    width: 64px;
    height: 64px;
}

ol.organizational-chart .staff.card .image-circle i {
    margin-top: 14px;
}

ol.organizational-chart .staff.card .detail {
    font-size: 12px;
    margin-top: 64px;
    margin-left: 0px;
}

ol.organizational-chart .staff.card .detail .position {
    line-height: 13px;
}

ol.organizational-chart .staff.card .detail .full-name {
    line-height: 13px;
}

ol.organizational-chart .staff.card .truncate {
    white-space: normal;
}

ol.organizational-chart .image-circle img.error,
ol.organizational-chart .image-circle img[src=""],
ol.organizational-chart .image-circle:not([data-src]),
ol.organizational-chart .avatar-fallback {
  /* display: block !important; */
  box-shadow: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/Org/chart/chart.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,2BAA2B,IAAI,aAAa;EAC5C,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,8BAA8B,OAAO,kBAAkB;EACvD,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,2BAA2B,IAAI,gCAAgC;EAC/D,gCAAgC;AAClC;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;;;IAGI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;;IAEI,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA,mBAAmB;AACnB;EACE,2BAA2B,IAAI,gCAAgC;EAC/D,gCAAgC;AAClC;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;;EAIE,+BAA+B;EAC/B,2BAA2B;AAC7B","sourcesContent":[".role-toggle-button {\r\n  width: 56px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 4px;\r\n  border: 2px solid #ffcc34;\r\n  border-radius: 999px;\r\n  padding: 2px 4px;\r\n  background: #fff;\r\n  color: #333;\r\n  cursor: pointer;\r\n  margin: 0 auto;\r\n  margin-top: -7px;\r\n  position: relative;\r\n  z-index: 1;\r\n  padding-right: 0px;\r\n}\r\n\r\n.role-toggle-button .material-icons {\r\n  font-size: 16px;\r\n  color: #555;\r\n}\r\n\r\n.role-toggle-count {\r\n  font-weight: 600;\r\n  font-size: 11px;\r\n  color: #333;\r\n}\r\n\r\n.role-toggle-button.active {\r\n  background: #fff !important;   /* ปุ่มปกติ */\r\n  border-color: #ffcc34 !important;\r\n  color: #333 !important;\r\n}\r\n\r\n.role-toggle-button {\r\n  background: #ffec9d !important;\r\n  border-color: #ffcc34 !important;\r\n  color: #222 !important;\r\n}\r\n\r\n.role-toggle-button:hover {\r\n  background: #ffb400 !important;      /* สีเมื่อ hover */\r\n  border-color: #ffb400 !important;\r\n  color: #fff !important;\r\n}\r\n\r\n.role-toggle-icon {\r\n  font-size: 14px !important;\r\n  color: #f5be28;\r\n}\r\n\r\n.staff:hover ~ .role-toggle-button {\r\n  transform: translateX(-6px);   /* ขยับไปซ้ายหรือเปลี่ยนสี ฯลฯ */\r\n  transition: transform 0.15s ease;\r\n}\r\n\r\nol.organizational-chart .staff.class-executive {\r\n    background-color: #024f42 !important;\r\n    color: #fff !important;\r\n}\r\n\r\nol.organizational-chart .staff.class-managing_director,\r\nol.organizational-chart .staff.class-general_manager,\r\nol.organizational-chart .staff.class-director {\r\n    background-color: #047775 !important;\r\n    color: #fff !important;\r\n}\r\n\r\nol.organizational-chart .staff.class-senior_manager,\r\nol.organizational-chart .staff.class-manager {\r\n    background-color: #55b493 !important;\r\n    color: #fff !important;\r\n}\r\n\r\nol.organizational-chart .staff {\r\n    background-color: #80b157;\r\n    color: #fff;\r\n}\r\n\r\n/* Box Staff Card */\r\nol.organizational-chart .staff.card ~ .role-toggle-button {\r\n  transform: translateX(-6px);   /* ขยับไปซ้ายหรือเปลี่ยนสี ฯลฯ */\r\n  transition: transform 0.15s ease;\r\n}\r\n\r\nol.organizational-chart .staff.card {\r\n    height: auto;\r\n    margin-left: 0px;\r\n    width: 144px;\r\n    border-radius: 8px;\r\n    margin-bottom: 0px;\r\n}\r\n\r\nol.organizational-chart .staff.card .photo {\r\n    top: 2px;\r\n    left: 50%;\r\n    margin-left: -5px;\r\n}\r\n\r\nol.organizational-chart .staff.card .image-circle {\r\n    width: 64px;\r\n    height: 64px;\r\n}\r\n\r\nol.organizational-chart .staff.card .image-circle i {\r\n    margin-top: 14px;\r\n}\r\n\r\nol.organizational-chart .staff.card .detail {\r\n    font-size: 12px;\r\n    margin-top: 64px;\r\n    margin-left: 0px;\r\n}\r\n\r\nol.organizational-chart .staff.card .detail .position {\r\n    line-height: 13px;\r\n}\r\n\r\nol.organizational-chart .staff.card .detail .full-name {\r\n    line-height: 13px;\r\n}\r\n\r\nol.organizational-chart .staff.card .truncate {\r\n    white-space: normal;\r\n}\r\n\r\nol.organizational-chart .image-circle img.error,\r\nol.organizational-chart .image-circle img[src=\"\"],\r\nol.organizational-chart .image-circle:not([data-src]),\r\nol.organizational-chart .avatar-fallback {\r\n  /* display: block !important; */\r\n  box-shadow: none !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
